package com.essntl.features.authentication.ui.auth

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.*
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.essntl.features.authentication.ui.auth.components.AuthCard
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.esIconPainterResource
import com.essntl.uikit.components.utils.esImagePainterResource
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun AuthScreen(
    state: AuthState,
    validation: AuthValidation,
    onEvent: (AuthEvent) -> Unit,
) {
    Row(
        modifier = Modifier
            .fillMaxSize()
            .padding(2.spacing),
    ) {
        Box(
            modifier = Modifier
                .weight(1f)
                .fillMaxSize(),
        ) {
            Row(
                horizontalArrangement = Arrangement.Center,
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier.align(Alignment.TopStart),
            ) {
                Image(
                    painter = esIconPainterResource(EsIcons.Logo),
                    contentDescription = "Logo",
                    modifier =
                    Modifier
                        .width(80.dp)
                        .height(96.dp),
                )

                Spacer(modifier = Modifier.width(1.spacing))

                Text(
                    text = "Odia",
                    textAlign = TextAlign.Center,
                    color = MaterialTheme.esColorScheme.textPrimary,
                    style = MaterialTheme.esTypography.h2Bold32,
                )
            }

            AuthCard(
                state = state,
                validation = validation,
                onEvent = onEvent,
                modifier = Modifier
                    .wrapContentHeight()
                    .fillMaxWidth(0.6f)
                    .align(Alignment.Center),
            )
        }

        Image(
            painter = esImagePainterResource(EsIcons.AuthPicture),
            contentDescription = "Auth Picture",
            modifier = Modifier
                .weight(1f)
                .fillMaxHeight()
                .fillMaxWidth(0.9f),
        )
    }
}
